var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({height: _vm.height, '--itemDisplay': _vm.itemDisplay, '--itemFloat': _vm.itemFloat, '--itemWidth': _vm.itemWidth})},[_c('div',{class:_vm.hasCategory? 'table-list table-category': 'table-list'},[_c('div',{staticClass:"category"},[_vm._t("category")],2),_c('div',{staticClass:"table"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }